import { Button } from "@mui/material";
import { HOST_URL } from "../common";
import { useEffect, useState } from "react";
import Menu from "../component/menu";
import ReactPaginate from "react-paginate";
import Register from "../component/register";
import "../Main.css";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import UpdateInfo from "../component/updateInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faBars,
  faUserSlash,
  faCrown,
} from "@fortawesome/free-solid-svg-icons";
import { Dropdown } from "react-bootstrap";
import { pastelColors as color } from "../colors";

const Management = () => {
  const [members, setMembers] = useState([]);
  const [switchState, setSwitchState] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateUser, setUpdateUser] = useState();
  const [isMobile] = useState(window.matchMedia("(max-width : 500px)").matches);
  const navigate = useNavigate();
  useEffect(() => {
    getMembers();

    const checkAdmin = () => {
      const url = HOST_URL + ":3002/checklogin";
      fetch(url, {
        method: "GET",
        credentials: "include",
      })
        .then((res) => res.json())
        .then((result) => {
          if (result.userLevel !== "0") {
            navigate("/");
          }
        });
    };
    checkAdmin();
  }, [switchState, navigate]);

  const getMembers = async () => {
    const url = HOST_URL + ":3002/getMember";
    const res = await fetch(url, {
      method: "GET",
      credentials: "include",
    });
    const data = await res.json();
    ///////////////////////
    const result = Object.entries(data);
    const ceo = result[6];
    result.splice(6, 1);
    const newResult = [ceo, ...result];
    setMembers(newResult);
    ///////////////////////
    // setMembers(Object.entries(data));
  };

  const deleteMember = (id) => {
    const url = HOST_URL + ":3002/deleteMember";
    const postBody = { id: id };

    console.log("request data : ", JSON.stringify(postBody));

    fetch(url, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(postBody),
      credentials: "include",
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.code === "ok") {
          window.alert("회원정보를 삭제하였습니다.");
          setSwitchState((current) => !current);
        } else if (result.code === "error") {
          window.alert(result.reason);
        }
      });
  };

  //////pagination

  const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = members.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(members.length / itemsPerPage);
  const handlePageClick = (e) => {
    const newOffset = (e.selected * itemsPerPage) % members.length;
    setItemOffset(newOffset);
  };
  function MembersList({ currentItems }) {
    return (
      <>
        {currentItems &&
          currentItems.map((member, index) => (
            <MembersLists key={member[1].id}>
              <MemberSpan>{index + 1 + itemOffset}</MemberSpan>
              <div
                style={{
                  width: "fit-content",
                }}
              >
                <MemberSpan
                  department={
                    member[1].department === "최고기술경영자"
                      ? color.yellow
                      : member[1].department === "콘텐츠사업부"
                      ? color.blue
                      : member[1].department === "한국공간정보연구소"
                      ? color.orange
                      : member[1].department === "경영기획"
                      ? color.red
                      : member[1].department === "전략기획"
                      ? color.purple
                      : member[1].department === '마케팅사업부'
                      ? color.navy
                      : color.lightgreen
                  }
                  style={{ padding: "0px 5px" }}
                >
                  {member[1].department}
                </MemberSpan>
              </div>
              <MemberSpan>
                {member[1].level === "0" ? (
                  <FontAwesomeIcon
                    icon={faCrown}
                    size="sm"
                    style={{ color: "#FFD700" }}
                  />
                ) : member[1].level === "1" ? (
                  <FontAwesomeIcon
                    icon={faCrown}
                    size="sm"
                    style={{ color: "#AAA9AD" }}
                  />
                ) : null}
                &nbsp;{member[1].name}
              </MemberSpan>
              <MemberSpan>{member[1].position}</MemberSpan>
              <MemberSpan>{member[1].id}</MemberSpan>
              <MemberSpan>
                {member[1].mailTo === "None" ? "" : member[1].mailTo}
              </MemberSpan>
              <MemberSpan>
                {!isMobile ? (
                  <Dropdown>
                    <Dropdown.Toggle
                      size="sm"
                      style={{
                        backgroundColor: "inherit",
                        color: "black",
                        border: "none",
                      }}
                    >
                      <FontAwesomeIcon icon={faBars} size="sm" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        size="xs"
                        onClick={() => {
                          setShowUpdateModal((current) => !current);
                          setUpdateUser(member[1]);
                        }}
                      >
                        <FontAwesomeIcon icon={faPen} size="xs" />
                        수정하기
                      </Dropdown.Item>
                      <Dropdown.Item
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        size="xs"
                        onClick={() =>
                          window.confirm(
                            `정말로 ${member[1].name}님의 회원정보를 삭제하시겠습니까?`
                          )
                            ? deleteMember(member[1].id)
                            : null
                        }
                      >
                        <FontAwesomeIcon icon={faUserSlash} size="xs" />
                        삭제하기
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                ) : (
                  <Dropdown>
                    <Dropdown.Toggle
                      size="sm"
                      style={{
                        width: "10px",
                        display: "flex",
                        justifyContent: "center",
                        padding: "3px 5px",
                        backgroundColor: "inherit",
                        color: "black",
                        border: "none",
                      }}
                    ></Dropdown.Toggle>
                    <Dropdown.Menu style={{ fontSize: "13px" }}>
                      <Dropdown.Item
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        size="xs"
                        onClick={() => {
                          setShowUpdateModal((current) => !current);
                          setUpdateUser(member[1]);
                        }}
                      >
                        <FontAwesomeIcon icon={faPen} size="xs" />
                        수정하기
                      </Dropdown.Item>
                      <Dropdown.Item
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        size="xs"
                        onClick={() =>
                          window.confirm(
                            `정말로 ${member[1].name}님의 회원정보를 삭제하시겠습니까?`
                          )
                            ? deleteMember(member[1].id)
                            : null
                        }
                      >
                        <FontAwesomeIcon icon={faUserSlash} size="xs" />
                        삭제하기
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </MemberSpan>
            </MembersLists>
          ))}
      </>
    );
  }
  return (
    <>
      <div
        className="Main-container"
        style={{ paddingTop: isMobile ? "" : "100px" }}
      >
        <Menu />
        <Title>회원 관리</Title>
        <div style={{ fontSize: "16px", width: "95%", maxWidth: "1400px" }}>
          <TotalMemberDiv>
            총원: &nbsp;<TotalMember>{` ${members.length}`}</TotalMember>명
          </TotalMemberDiv>
          <ListName>
            <span></span>
            <span style={{ paddingBottom: "4px" }}>부서</span>
            <span style={{ paddingBottom: "4px" }}>이름</span>
            <span style={{ paddingBottom: "4px" }}>직급</span>
            <span style={{ paddingBottom: "4px" }}>이메일</span>
            <span style={{ paddingBottom: "4px" }}>최종 보고자</span>
          </ListName>
          <MembersList currentItems={currentItems} />
          <ManageDiv>
            {!isMobile ? (
              <Button
                variant="contained"
                style={{
                  fontSize: "20px",
                  border: "1px solid black",
                  height: "40px",
                }}
                onClick={() => {
                  setModalShow((current) => !current);
                }}
              >
                회원 등록
              </Button>
            ) : (
              <Button
                variant="contained"
                style={{
                  fontSize: "12px",
                  border: "1px solid black",
                  height: "25px",
                }}
                onClick={() => {
                  setModalShow((current) => !current);
                }}
              >
                회원 등록
              </Button>
            )}
          </ManageDiv>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "50px",
            }}
          >
            {!isMobile ? (
              <ReactPaginate
                previousLabel="<"
                nextLabel=">"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName="pagination"
                activeClassName="active"
              />
            ) : (
              <ReactPaginate
                previousLabel="<"
                nextLabel=">"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName="pagination"
                activeClassName="active"
              />
            )}
          </div>
        </div>
        <Register
          setSwitchState={setSwitchState}
          modalShow={modalShow}
          setModalShow={setModalShow}
        />
        {showUpdateModal ? (
          <UpdateInfo
            updateUser={updateUser}
            setSwitchState={setSwitchState}
            showUpdateModal={showUpdateModal}
            setShowUpdateModal={setShowUpdateModal}
          />
        ) : null}
      </div>
    </>
  );
};

export default Management;

const ManageDiv = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 2%;

  @media screen and (max-width: 500px) {
    margin-top: 5%;
  }
`;
const TotalMemberDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 5px;
  font-size: 20px;
  @media screen and (max-width: 500px) {
    font-size: 15px;
  }
`;
const TotalMember = styled.span`
  color: yellow;
`;

const MembersLists = styled.div`
  display: grid;
  grid-template-columns: 3% 28% 14% 14% 28% 9% 4%;
  place-items: center;
  padding-top: 6px;
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  color: black;
  background-color: white;

  @media screen and (max-width: 500px) {
    grid-template-columns: 4% 29% 12% 12% 27% 12% 4%;
    font-size: 10px;
    padding: 8px 0 8px 0;
  }
`;

const MemberSpan = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  word-break: break-all;
  background-color: ${(props) => props.department};
`;

const ListName = styled.div`
  width: 100%;
  display: grid;
  align-items: center;
  grid-template-columns: 3% 28% 14% 14% 28% 9% 4%;
  border: 1px solid white;
  @media screen and (max-width: 500px) {
    grid-template-columns: 4% 29% 12% 12% 27% 12% 4%;
    font-size: 10px;
    width: 100%;
  }
`;

const Title = styled.span`
  font-size: 30px;
  @media screen and (max-width: 1000px) {
    margin-top: 5%;
  }
  @media screen and (max-width: 500px) {
    font-size: 20px;
    margin-top: 17%;
  }
`;
